export default defineNuxtPlugin((nuxtApp) => {
    const userSession = useUserSessionStore();

    // Reading tokens from cookies on initial page load or page refresh
    // Doing this in plugin to ensure it happens before any middleware runs (like auth middleware)
    callOnce('userSession', () => userSession.init());
});
